import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2, Search, Download } from "lucide-react";
import { api } from "../../../lib/auth";

export default function StoreSubscribers() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  const load = () => api.get("/t/store/subscribers").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove subscriber?")) return;
    await api.delete(`/t/store/subscribers/${id}`);
    toast.success("Removed");
    load();
  };

  const exportCSV = () => {
    const csv = "email,subscribed_at\n" + rows.map((r) => `${r.email},${r.created_at}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  const filtered = rows.filter((r) => !search || r.email?.toLowerCase().includes(search.toLowerCase()));

  return (
    <div data-testid="subscribers-page" className="p-6 lg:p-8">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="font-display font-extrabold text-3xl text-black tracking-tight">Subscribers</h1>
          <div className="text-sm text-black/55 mt-1">Store · Subscribers · {rows.length} total</div>
        </div>
        <button onClick={exportCSV} data-testid="subscribers-export"
          className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-white border border-black/10 text-sm font-semibold hover:border-black/25">
          <Download size={13} /> Export CSV
        </button>
      </div>

      <div className="flex items-center gap-2 bg-white rounded-xl border border-black/10 px-3 py-2 max-w-md mb-5">
        <Search size={16} className="text-black/40" />
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search email…"
          data-testid="subscribers-search"
          className="flex-1 bg-transparent focus:outline-none text-sm" />
      </div>

      <div className="bg-white rounded-2xl border border-black/5 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#FAFBFD] text-black/55 text-[11px] uppercase tracking-wider">
            <tr>
              <th className="text-left p-3.5 font-bold">Email</th>
              <th className="text-left p-3.5 font-bold">Subscribed</th>
              <th className="text-right p-3.5 font-bold">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-black/5">
            {filtered.map((r) => (
              <tr key={r.id} className="hover:bg-[#FAFBFD]">
                <td className="p-3.5 flex items-center gap-2">
                  <Mail size={14} className="text-[#1FA868]" /> <span className="font-semibold text-black">{r.email}</span>
                </td>
                <td className="p-3.5 text-black/55 text-xs">{(r.created_at || "").slice(0, 10)}</td>
                <td className="p-3.5 text-right">
                  <button onClick={() => remove(r.id)} data-testid={`subs-remove-${r.email}`}
                    className="p-2 rounded-md bg-rose-50 text-rose-600 hover:bg-rose-100"><Trash2 size={13} /></button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="3" className="p-10 text-center text-black/45">No subscribers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
